import { useQueryClient } from "@tanstack/react-query";

import { rqClient } from "@/shared/api/instance";
import type { ApiSchemas } from "@/shared/api/schema";

type CheckoutRequest = ApiSchemas["CheckoutRequest"];
type CheckoutResponse = ApiSchemas["CheckoutResponse"];

export function useCheckout() {
  const queryClient = useQueryClient();

  return rqClient.useMutation("post", "/api/v1/cart/checkout", {
    mutationKey: ["cart", "checkout"],
    onSuccess: async () => {
      // Cart and cart items (cleared after checkout)
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/cart"),
      );
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/cart_items"),
      );

      // New purchase created for buyer
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/purchases"),
      );

      // New sales created for sellers
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/sales"),
      );

      // Balance deducted
      await queryClient.invalidateQueries(
        rqClient.queryOptions("get", "/api/v1/balance"),
      );

      // Product quantities decreased (invalidate all product queries)
      await queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return (
            Array.isArray(key) &&
            key[0] === "get" &&
            typeof key[1] === "string" &&
            key[1].startsWith("/api/v1/products")
          );
        },
      });
    },
  });
}

export type { CheckoutRequest, CheckoutResponse };
